import { useNavigate } from 'react-router';
import Logo from "../App/Logo"
import Center from "../App/Center"

export default function Header( props ) {
  const navigate = useNavigate();
  return (
		<Center
			onClick={ e => { e.preventDefault(); navigate(-1); } }
			mainStyle={{ cursor:'pointer', background:'#000' }}
			style={{ margin:0, padding:'5px 30px 5px 30px', background:'#000', color:'#fff' }}
	 	>
	  	<div style={{ display:'flex', alignItems:'center' }} >
	    	<div
	    		className="material-symbols-outlined" 
	    		style={{ fontWeight:700, flexGrow:1, color:'#fff', fontSize:32 }} 
	  		>
					chevron_left
				</div>
				<Logo style={{ flexGrow:999, textAlign:'center', transform:'scale(.65)',  }} />
	    	<div style={{ flexGrow:1, width:32 }} />
			</div>
		</Center>
	)
}
